import { cn } from '@repo/ui/lib/utils';

import { CandidateInfoAttributes } from './attributes/component';
import { CandidateInfoContact } from './contact/component';
import {
  CandidateInfoAbout,
  CandidateInfoAboutConfig,
} from './about/component';
import { CandidateInfoBio } from './bio/component';
import { Submission } from '@repo/api/open-calls/graphql';

export type CandidateInfoConfig = {
  about?: CandidateInfoAboutConfig;
  parseBioAsQa?: boolean;
  showAttributes?: boolean;
  showBio?: boolean;
  showContact?: boolean;
};

export type CandidateProps = {
  candidate: Submission;
  className?: string;
  detailsConfig?: CandidateInfoConfig;
  isInModal?: boolean;
  isAmericanStyleOpenCall?: boolean;
};

export function CandidateInfo({
  candidate,
  className,
  detailsConfig,
  isInModal,
  isAmericanStyleOpenCall = false,
}: CandidateProps) {
  const resolvedConfig = {
    showContact: detailsConfig?.showContact === true,
    showBio: detailsConfig?.showBio === true,
    showAttributes: detailsConfig?.showAttributes === true,
    parseBioAsQa: detailsConfig?.parseBioAsQa === true,
  };

  return (
    <div className={cn('flex flex-col', className)}>
      {detailsConfig?.about && (
        <CandidateInfoAbout
          aboutConfig={detailsConfig.about}
          candidate={candidate}
        />
      )}
      {resolvedConfig.showContact && (
        <CandidateInfoContact candidate={candidate} truncate={isInModal} />
      )}
      {resolvedConfig.showBio && (
        <CandidateInfoBio
          candidate={candidate}
          parseBioAsQa={resolvedConfig.parseBioAsQa}
          isAmericanStyleOpenCall={isAmericanStyleOpenCall}
        />
      )}
      {resolvedConfig.showAttributes && (
        <CandidateInfoAttributes candidate={candidate} />
      )}
      {/*<CandidateInfoSocial candidate={candidate} />*/}
    </div>
  );
}
